import { apiFetch } from './utils/api';

export const expertInputDocuments = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    if (!args.expertInputId) {
      throw new Error('Expert input ID is required for this API endpoint');
    }

    const url = `/v2/expert-inputs/${args.expertInputId}/documents`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    if (body) {
      return body;
    } else {
      return { data: [] };
    }
  },
};
